import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
var ActionItem = /*#__PURE__*/function (_PureComponent) {
  _inherits(ActionItem, _PureComponent);
  var _super = _createSuper(ActionItem);
  function ActionItem(props) {
    var _this;
    _classCallCheck(this, ActionItem);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleAction", function (_ref) {
      var payload = _ref.payload;
      var _this$props = _this.props,
        action = _this$props.action,
        handleActionItemChange = _this$props.handleActionItemChange;
      handleActionItemChange({
        type: action,
        payload: payload
      });
      _this.setState({
        value: payload
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (params) {
      var _this$props2 = _this.props,
        action = _this$props2.action,
        handleActionItemChange = _this$props2.handleActionItemChange;
      handleActionItemChange({
        type: action,
        payload: {
          value: params
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (params) {
      var _this$props3 = _this.props,
        action = _this$props3.action,
        handleActionItemChange = _this$props3.handleActionItemChange;
      handleActionItemChange({
        type: action,
        payload: {
          value: params
        }
      });
      _this.setState({
        value: params
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getActionItemValue", function () {
      var _this$props4 = _this.props,
        renderOptions = _this$props4.renderOptions,
        value = _this$props4.value;
      var _ref2 = renderOptions || EMPTY_OBJECT,
        _ref2$controlledActio = _ref2.controlledActionItem,
        controlledActionItem = _ref2$controlledActio === void 0 ? false : _ref2$controlledActio;
      if (controlledActionItem) return value;
      var valueFromState = _this.state.value;
      return valueFromState;
    });
    var _value = props.value;
    _this.state = {
      value: _value
    };
    return _this;
  }
  _createClass(ActionItem, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        renderer = _this$props5.renderer,
        renderOptions = _this$props5.renderOptions,
        action = _this$props5.action,
        handleActionItemChange = _this$props5.handleActionItemChange,
        actionContainerClassName = _this$props5.actionContainerClassName;
      var Component = renderer;
      return /*#__PURE__*/React.createElement("div", {
        className: actionContainerClassName
      }, /*#__PURE__*/React.createElement(Component, _extends({
        onAction: this.handleAction,
        onClick: this.handleClick,
        onChange: this.handleChange,
        handleAction: handleActionItemChange,
        id: action,
        value: this.getActionItemValue()
      }, renderOptions)));
    }
  }]);
  return ActionItem;
}(PureComponent);
export default ActionItem;